import React, { FC, useState } from "react";

import { MarkerF } from "@react-google-maps/api";
import MultipleRidesMarkerTooltip from "../MultipleRidesGoogleMap/MultipleRidesMarkerTooltip";
import { ObjectRideLocation } from "../MultipleRidesGoogleMap/types";

interface MakerProps {
  marker: ObjectRideLocation;
  objectName: string;
  icon: google.maps.Icon;
  isDotMarker: boolean;
  title?: string;
  onClick?: (marker: ObjectRideLocation) => void;
  children?: React.ReactNode;
}

const ObjectRideGoogleMapMarker: FC<MakerProps> = ({
  marker,
  objectName,
  icon,
  isDotMarker,
  title,
  onClick,
  children
}: MakerProps) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  return (
    <>
      <MarkerF
        position={{
          lat: marker.latitude ?? 0,
          lng: marker.longitude ?? 0
        }}
        onClick={() => onClick && onClick({ ...marker })}
        icon={icon}
        title={title}
        onMouseOver={() => setIsTooltipVisible(true)}
        onMouseOut={() => setIsTooltipVisible(false)}
      >
        {children}
      </MarkerF>
      {isTooltipVisible && (
        <MultipleRidesMarkerTooltip
          marker={marker}
          objectName={objectName}
          isDotMarker={isDotMarker}
        />
      )}
    </>
  );
};

export default React.memo(ObjectRideGoogleMapMarker);
